import { createSlice, PayloadAction } from '@reduxjs/toolkit';
export type User = {
    Id: string | undefined;
};

export type TUserInfo = {
    token?: string | null;
    refreshToken?: string | null;
    expires_in?: number | null;
    created_on?: string | null;
    is_admin?: boolean | null;
    phone?: string | null;
    tenant?: number | null;
    username?: string | undefined;
} & Partial<User>;

const initialState: TUserInfo = JSON.parse(
    window.localStorage.getItem('userInfo') || '{}'
);

const userInfoSlice = createSlice({
    name: 'userInfo',
    initialState,
    reducers: {
        setUserInfo: (state: TUserInfo, action: PayloadAction<TUserInfo>) => {
            Object.entries(action.payload).forEach(([key, value]) => {
                // A little bit of magic to make sure that the state is immutable
                state[key as keyof TUserInfo] = value as any;
            });
            // Merge from local storage
            const localState = JSON.parse(
                window.localStorage.getItem('userInfo') || '{}'
            );
            window.localStorage.setItem(
                'userInfo',
                JSON.stringify({ ...localState, ...state })
            );
        },
        removeUserInfo: () => {
            window.localStorage.removeItem('userInfo');
            return {};
        },
        setToken: (state: TUserInfo, action: PayloadAction<string>) => {
            state.token = action.payload;
            window.localStorage.setItem(
                'userInfo',
                JSON.stringify({ ...state })
            );
        },
    },
});

export const { setUserInfo, removeUserInfo, setToken } = userInfoSlice.actions;

export default userInfoSlice.reducer;
